const breakpoints = {
  extraSmall: 499,
  small: 767,
  medium: 999,
  large: 1420,
  filter: 800,
};

export default breakpoints;
